import datapoints from '../datapoints';
import { Button, ButtonType } from 'office-ui-fabric-react/lib/Button';
import { Dialog, DialogFooter, DialogType } from 'office-ui-fabric-react/lib/Dialog';
import { logUsage } from 'owa-analytics';
import { optIntoJsmvvmClientAndRedirect } from 'owa-optin';
import { setClientOptedIn } from 'owa-mail-store-actions';
import WebSessionType from 'owa-service/lib/contract/WebSessionType';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import commonStrings from 'owa-strings/owa-common-strings';
import strings from 'owa-strings/owa-mail-strings';
import * as React from 'react';
import * as ReactDOM from 'react-dom';

const styles = require('./OptOutDialog.scss');

export interface OptOutDialogProps {
    onClose: () => void;
    modulePath: string;
    isConsumer: boolean;
}

export interface OptOutDialogState {
    isShown: boolean;
}

export class OptOutDialog extends React.Component<OptOutDialogProps, OptOutDialogState> {
    constructor(props: OptOutDialogProps) {
        super(props);
        this.state = {
            isShown: true,
        };
    }

    private onDismiss = () => {
        this.setState({
            isShown: false,
        });

        setClientOptedIn(true);
        logUsage(datapoints.optOutCancelDatapoint.datapoint.name);

        this.props.onClose();
    };

    private onShareThoughts = () => {
        logUsage(datapoints.optOutShareThoughtsDatapoint.datapoint.name);
        const target = this.props.isConsumer
            ? 'https://outlook.uservoice.com/forums/601444-outlook-com-beta'
            : 'https://outlook.uservoice.com/forums/907141';
        window.open(target, '_blank');

        this.completeOptOut();
    };

    private onNotNow = () => {
        logUsage(datapoints.optOutDontShareThoughtsDatapoint.datapoint.name);
        this.completeOptOut();
    };

    private completeOptOut = () => {
        this.setState({
            isShown: false,
        });

        optIntoJsmvvmClientAndRedirect(this.props.modulePath);
    };

    render() {
        const { isConsumer } = this.props;
        return (
            <Dialog
                hidden={!this.state.isShown}
                dialogContentProps={{
                    title: isConsumer
                        ? strings.optOutFeedbackTitle
                        : strings.optOutEnterpriseFeedbackTitle,
                    subText: isConsumer
                        ? strings.optOutFeedbackSubtitle
                        : strings.optOutEnterpriseFeedbackSubtitle,
                    type: DialogType.normal,
                }}
                modalProps={{
                    containerClassName: styles.optOutDialog,
                }}
                onDismiss={this.onDismiss}>
                <DialogFooter>
                    <Button
                        buttonType={ButtonType.primary}
                        onClick={this.onShareThoughts}
                        title={commonStrings.opensANewWindow}>
                        {isConsumer ? strings.optOutFeedbackOk : strings.optOutEnterpriseFeedbackOk}
                    </Button>
                    <Button buttonType={ButtonType.normal} onClick={this.onNotNow}>
                        {isConsumer
                            ? strings.optOutFeedbackCancel
                            : strings.optOutEnterpriseFeedbackCancel}
                    </Button>
                    }
                </DialogFooter>
            </Dialog>
        );
    }
}

export default function showOptOutDialog(modulePath?: string) {
    // Show the opt out dialog
    // This had to be made distinct from owa-confirm-dialog because some pop up blockers (IE11)
    // didn't like the window.open call being outside of the button click handler.
    const optOutDialogDiv = document.createElement('div');
    optOutDialogDiv.id = 'optOutDialog';
    document.body.appendChild(optOutDialogDiv);

    const isConsumer =
        getUserConfiguration().SessionSettings.WebSessionType === WebSessionType.ExoConsumer;
    ReactDOM.render(
        <OptOutDialog
            onClose={() => {
                ReactDOM.unmountComponentAtNode(optOutDialogDiv);
                document.body.removeChild(optOutDialogDiv);
            }}
            modulePath={modulePath}
            isConsumer={isConsumer}
        />,
        optOutDialogDiv
    );
}
